export enum TransactionStateHumanReadable {
  VOID_AUTHORISED = 'VOID AUTHORISED',
  REFUND_AUTHORISED = 'REFUND AUTHORISED',
  VOID_AUTHORIZED = 'VOID AUTHORIZED',
  REFUND_AUTHORIZED = 'REFUND AUTHORIZED',
  REFUND_SETTLED = 'REFUND SETTLED',
}
